import { render, staticRenderFns } from "./ResetPasswordLayout.vue?vue&type=template&id=1da9de13&"
import script from "./ResetPasswordLayout.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordLayout.vue?vue&type=style&index=0&id=1da9de13&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da9de13')) {
      api.createRecord('1da9de13', component.options)
    } else {
      api.reload('1da9de13', component.options)
    }
    module.hot.accept("./ResetPasswordLayout.vue?vue&type=template&id=1da9de13&", function () {
      api.rerender('1da9de13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/ResetPasswordLayout.vue"
export default component.exports